
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"35.382","height":"35.381"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.382 17.69A17.691 17.691 0 1117.691 0a17.69 17.69 0 0117.691 17.69","fill":"#00d95f"}}),_c('path',{attrs:{"d":"M8.132 27.702l1.475-5.5a10.184 10.184 0 114.057 4.022zm5.807-3.545l.348.208a8.272 8.272 0 10-2.828-2.8l.213.351-.823 3.072z","fill":"#fff"}}),_c('path',{attrs:{"d":"M22.274 18.702a1.7 1.7 0 00-1.455-.328c-.378.154-.619.746-.864 1.049a.365.365 0 01-.469.1 6.586 6.586 0 01-3.289-2.818.4.4 0 01.051-.551 2.229 2.229 0 00.6-.97 2.122 2.122 0 00-.267-1.148 2.72 2.72 0 00-.847-1.277 1.161 1.161 0 00-1.262.187 2.559 2.559 0 00-.888 2.028 2.889 2.889 0 00.08.644 5.341 5.341 0 00.617 1.424 11.421 11.421 0 00.645.98 9.952 9.952 0 002.8 2.6 8.423 8.423 0 001.744.829 3.874 3.874 0 002.03.321 2.46 2.46 0 001.841-1.37 1.191 1.191 0 00.085-.7c-.1-.481-.756-.768-1.146-1","fill-rule":"evenodd","fill":"#fff"}})])
          )
        }
      }
    